export default __webpack_public_path__ + "static/media/mask.e52e008a.png";